import { CSSProperties, FC } from 'react';
import { Pagination, Navigation } from 'swiper/modules';
import { SwiperSlide } from 'swiper/react';

import { Colors, Breakpoints } from '@lichtblick/theme';
import { Container } from '@lichtblick/ui-components';

import { CasesSliderContentWrapper, CasesSliderRoot, SliderContainer } from './CasesSlider.styles';
import { CasesSliderCard } from './CasesSliderCard';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { CasesSliderType } from '../../../types';
import { getColor } from '../../../utils';
import { MTextIntro } from '../../MTextIntro';
import { BasicSlider } from '../shared/Slider/BasicSlider';
import { Fade } from '../shared/Slider/Fade';
import { SliderNavigationButtons } from '../shared/Slider/SliderNavigationButtons';

const CasesSliderInner: FC<CasesSliderType> = ({ _uid, customCss = '', slides, textIntro, theme }) => {
  const customClassName = `custom-css-${_uid}`;
  const styleContent = `.${customClassName}{${customCss}}`;

  return (
    <>
      {customCss && <style dangerouslySetInnerHTML={{ __html: styleContent }} type="text/css"></style>}
      <CasesSliderRoot
        $backgroundColor={(theme ? getColor(theme) : undefined) || Colors.BackgroundGray}
        className={customClassName}
      >
        <CasesSliderContentWrapper>
          <Container as="div">
            <MTextIntro {...textIntro[0]} centeredDesktop centeredMobile />
          </Container>
          <SliderContainer $slideCount={slides.length} className="foo">
            <style type="text/css">{`.swiper-slide{height: auto;}`}</style>
            <BasicSlider
              aria-label="Fallbeispiele"
              aria-roledescription="Karussell"
              breakpoints={{
                [Breakpoints.Small]: {
                  slidesPerView: slides.length > 2 ? 2.2 : 2,
                  enabled: slides.length > 2,
                  slidesOffsetBefore: slides.length > 2 ? 16 : 0,
                  pagination: {
                    enabled: slides.length > 2,
                  },
                },
              }}
              data-testid="CasesSlider"
              modules={[Pagination, Navigation]}
              navigation={{ nextEl: 'custom-next', prevEl: 'custom-prev' }}
              pagination={{ clickable: true, enabled: true }}
              role="region"
              slidesOffsetAfter={16}
              slidesOffsetBefore={16}
              slidesPerView={1.15}
              spaceBetween={20}
              style={{} as CSSProperties}
            >
              {slides.map((slide, index) => (
                <SwiperSlide
                  aria-label={`Folie ${index}`}
                  data-testid={`CasesSlider-Slide-${index}`}
                  // eslint-disable-next-line react/no-array-index-key
                  key={`CasesSlider-Slide-${index}`}
                >
                  <CasesSliderCard {...slide} backgroundColor={theme === 'white' ? Colors.FadedMoss : Colors.White} />
                </SwiperSlide>
              ))}
              <Fade color={Colors.BackgroundGray} slideCount={slides.length} />
              <SliderNavigationButtons
                data-testid-prefix="CasesSlider"
                numPages={{ [Breakpoints.Small]: slides.length - 1, mobile: slides.length }}
              />
            </BasicSlider>
          </SliderContainer>
        </CasesSliderContentWrapper>
      </CasesSliderRoot>
    </>
  );
};

export default CasesSliderInner;
